import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

/** Convert a webPath from Capacitor Camera to a File object. */
export async function webPathToFile(webPath: string, format: string, index: number): Promise<File> {
  const response = await fetch(webPath);
  const blob = await response.blob();
  const mimeType = blob.type || `image/${format || "jpeg"}`;
  const ext = format || "jpeg";
  return new File([blob], `photo_${Date.now()}_${index}.${ext}`, { type: mimeType });
}

/** Open camera directly → single photo. */
export async function pickFromCamera(): Promise<File[]> {
  const photo = await Camera.getPhoto({
    quality: 90,
    resultType: CameraResultType.Uri,
    source: CameraSource.Camera,
  });
  if (!photo.webPath) return [];
  const file = await webPathToFile(photo.webPath, photo.format, 0);
  return [file];
}

/** Open photo library → multiple images. */
export async function pickFromLibrary(): Promise<File[]> {
  const result = await Camera.pickImages({
    quality: 90,
    limit: 0,
  });
  const files: File[] = [];
  for (let i = 0; i < result.photos.length; i++) {
    const photo = result.photos[i];
    if (!photo.webPath) continue;
    const file = await webPathToFile(photo.webPath, photo.format, i);
    files.push(file);
  }
  return files;
}
